import { User } from "@/api/user/userTypes";
import { ReactNode } from "react";
import { useSearchParams } from "react-router-dom";

import NavigationHeader from "../NavigationHeader";

export function Page({
  children,
  currentUser,
}: {
  children: ReactNode;
  currentUser?: User;
}) {
  const [searchParams] = useSearchParams();

  const is3dsIframe = searchParams.get("field_passthrough7");

  return (
    <div className="mt-12 relative overflow-y-auto  sm:mt-20 w-full">
      {!is3dsIframe && <NavigationHeader user={currentUser} />}
      {children}
    </div>
  );
}
